const styleSheet = () => ({
  inputContainer: {
    display: 'flex',
    width: (props) => (props.width && `${props.width}px`) || '135px',
    position: 'relative',
  },
  indicator: {
    overflow: 'visible',
    top: '10px',
    left: '25px',
    position: 'relative',
    padding: '4.5px',
    margin: '-4.5px',
    cursor: (props) => props.searchable && 'pointer',
    zIndex: 99,
  },
  clearButton: {
    top: '8px',
    right: '15px',
    position: 'absolute',
    cursor: 'pointer',
  },
  oval: {
    display: 'flex',
    boxSizing: 'border-box',
    height: '18.67px',
    width: '18.67px',
    border: '1.63px solid #6373A4',
    borderRadius: '100%',
    transform: 'rotate(315deg)',
    padding: '3px 0px 0px 6px',
    position: 'relative',
  },
  cross: {
    height: '8.3px',
    width: '1.56px',
    borderRadius: '1.17px',
    backgroundColor: '#6373A4',
    position: 'relative',
  },
  forward: {
    transform: 'rotate(90deg)',
    left: '10%',
  },
  backward: {
    transform: 'rotate(180deg)',
  },
  errorStyle: {
    bottom: '-18px',
    left: '30px',
    height: '15px',
    width: '218px',
    color: '#FF6969',
    position: 'absolute',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '15px',
  },
  disabledStyle: {
    opacity: '30%',
    pointerEvents: 'none',
  },
  blue: {
    '& path': {
      fill: '#085FE5',
    },
  },
});

export default styleSheet;
